<template>
    <m-main-layout v-if="formData">
        <el-button size="small" type="primary" slot="right-btn" @click="$router.back()">返回列表
        </el-button>
        <div class="page-content-main">
            <el-form :model="formData" :rules="rules" ref="form" label-width="auto" class="margin-top" :key="refresh">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="formData.title" maxlength="100" style="width: 700px;"></el-input>
                    <el-row style="width: 700px" class="margin-top">
                        <el-col :span="12">
                            <one-checkbox v-model="formData.title_style.b">粗体</one-checkbox>
                            <one-checkbox v-model="formData.title_style.i">斜体</one-checkbox>
                            <one-checkbox v-model="formData.title_style.u">删除线</one-checkbox>
                        </el-col>
                        <el-col :span="12">
                            颜色：<color-select v-model="formData.title_style.c"></color-select>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="信息属性">
                    <el-row style="width: 700px">
                        <el-col :span="12">
                            <one-checkbox v-model="formData.is_tuijian">推荐</one-checkbox>
                            <one-checkbox v-model="formData.is_toutiao">头条</one-checkbox>
                        </el-col>
                        <el-col :span="12">
                            置顶级别：<sort-select v-model="formData.sort" style="width: 230px;"></sort-select><a class="hand margin-left" @click="formData.sort = ''">取消</a>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="公司全称" prop="tags">
                    <el-tag
                        :key="tag"
                        v-for="tag in formData.tags"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)" class="margin-right">
                        {{tag}}
                    </el-tag>
                    <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                        style="width: 100px;"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加公司全称</el-button>
                </el-form-item>
                <el-form-item label="标题图片" prop="head_img">
                    <head-img-upload v-model="formData.head_img"></head-img-upload>
                </el-form-item>
                <el-form-item label="标讯类型" prop="type_zd_id" v-if="formData.second_type=='coldBid'">
                    <type-select :data="{akey:'zd'}" clearable v-model="formData.type_zd_id" :can-add="false" style="width: 500px;"></type-select>
                </el-form-item>
                 <el-form-item label="需求类型" prop="type_demand_id" v-if="formData.second_type=='coldNeed'">
                    <type-select :data="{akey:'demand'}" clearable v-model="formData.type_demand_id" :can-add="false" style="width: 500px;"></type-select>
                </el-form-item>
                <el-form-item label="是否显示标讯类型" prop="show_zd">
                    <el-switch
                        v-model="formData.show_zd"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="显示"
                        inactive-text="不显示">
                    </el-switch>
                </el-form-item>
	            <el-form-item label="联系人" prop="name" :rules="[{required: true, message: '联系人必填'}]">
		            <el-input v-model="formData.name"  maxlength="15" show-word-limit style="width: 500px;"></el-input>
	            </el-form-item>
	            <el-form-item label="联系方式" prop="phone" :rules="[{required: true, message: '联系方式必填'},{pattern:$regexp.mobile,message:'请填写正确的手机号'}]">
		            <el-input v-model="formData.phone"  maxlength="15" show-word-limit style="width: 500px;"></el-input>
	            </el-form-item>
                <el-form-item label="行业类别" prop="type_industry_id">
                     <type-select :can-add="false"  v-model="formData.type_industry_id" :data="{akey:'industry'}"  style="width: 500px;"></type-select>
<!--                  <el-select  filterable v-model="formData.type_industry_id" placeholder="请选择" style="width: 500px;">-->
<!--                      <el-option-->
<!--                          v-for="item in industryList"-->
<!--                          :key="item.industryId"-->
<!--                          :label="item.industryCategoryName"-->
<!--                          :value="item.industryId"></el-option>-->
<!--                  </el-select>-->
                </el-form-item>
<!--                <el-form-item label="项目地区" prop="province_code">-->
<!--                    <area-select :data="{pid:[1,'<=']}" v-model="formData.province_code" @change="changeArea"  style="width: 500px;"></area-select>-->
<!--&lt;!&ndash;                    <province-select v-model="area" @change="changeProvince" style="width: 500px;"></province-select>&ndash;&gt;-->
<!--                </el-form-item>-->
	            <el-form-item label="服务类型" prop="type_fuwu_ids" :rules="[{required: true, message: '服务类型必选'}]">
		            <type-select multiple :can-add="false" v-model="formData.type_fuwu_ids" url="/Type/listAll" :data="{akey:'fuwu'}" style="width: 500px;"></type-select>
		            <!--                    <province-select v-model="area" @change="changeProvince" style="width: 500px;"></province-select>-->
	            </el-form-item>
	            <el-form-item label="区域" prop="province_codes" :rules="[{required: true, message: '区域必选'}]">
		            <area-select multiple :data="{pid:[1,'<='],orderBy:'code',sortBy:'asc'}" v-model="formData.province_codes" style="width: 500px;"></area-select>
	            </el-form-item>
                <el-form-item label="项目地址" prop="address">
                    <el-input v-model="formData.address" maxlength="200" style="width: 500px;"></el-input>
                </el-form-item>
<!--                <el-form-item label="地区" prop="province_code">-->
<!--                    <area-select v-model="formData.province_code" style="width: 500px;" @change="changeArea"></area-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="外链" prop="out_url">-->
<!--                    <el-input v-model="formData.out_url" maxlength="100" style="width: 500px;"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="查看权限" prop="user_vip_type">
                    <el-radio-group v-model="formData.user_vip_type" @change="change">
                        <el-radio label="free">完全公开</el-radio>
                        <el-radio label="user">注册会员</el-radio>
<!--	                    <el-radio label="mini">小程序</el-radio>-->
                        <el-radio label="vip">VIP</el-radio>
<!--                        <el-radio label="buy">单条购买</el-radio>-->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单价" prop="price" :rules="[
      { required: true,validator:this.$utils.rulePriceNotZero, message: '请输入正确的价格'}]" v-if="formData.user_vip_type === 'vip'">
                    <el-radio-group v-model="priceType" @change="changePriceType">
                        <el-radio :label="1">￥9.9</el-radio>
                        <el-radio :label="2">￥19.9</el-radio>
                        <el-radio :label="3">￥3880</el-radio>
                        <el-radio :label="4">其它</el-radio>
                    </el-radio-group>
                    <el-input v-model="formData.price" maxlength="100" style="margin-left:10px;width: 155px;"></el-input> 设置单条付费价格
                </el-form-item>
	            <el-form-item label="是否免解锁" prop="is_free">
		            <el-switch
			            v-model="formData.is_free"
			            active-color="#13ce66"
			            :active-value="1"
			            :inactive-value="0"
			            active-text="是"
			            inactive-text="否">
		            </el-switch>
	            </el-form-item>
                <el-form-item label="是否开启支付" prop="is_pay">
                    <el-switch
                        v-model="formData.is_pay"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="支付按钮描述" prop="pay_des">
                    <el-input v-model="formData.pay_des" maxlength="100" style="width: 500px;"></el-input>
                    <div>留空则使用全局设置；提示：{price}为金额占位符</div>
                </el-form-item>
                <el-form-item label="发布时间" prop="push_time">
	                <time-picker v-model="formData.push_time" style="width: 500px;"></time-picker>
<!--                    <push-time v-model="formData.push_time" now style="width: 500px;"></push-time>-->
                </el-form-item>
	            <el-form-item label="报名截止时间" prop="join_end_time" :rules="[{required: true, message: '报名截止时间必填'}]">
		            <push-time v-model="formData.join_end_time" style="width: 500px;"></push-time>
	            </el-form-item>
	            <el-form-item label="投标截止时间" prop="end_time" :rules="[{required: true, message: '投标截止时间必填'}]">
		            <time-picker v-model="formData.end_time" style="width: 500px;"></time-picker>
	            </el-form-item>
<!--                <template v-if="routerData.type === 'device' || routerData.type === 'storage'">-->
<!--                    <el-form-item prop="join_end_time" label="报名截止时间" :rules="[{required: formData.is_join_end_long === 0, message: '报名截止时间必填'}]">-->
<!--                        是否长期有效：-->
<!--                        <el-switch-->
<!--                            v-model="formData.is_join_end_long"-->
<!--                            active-color="#13ce66"-->
<!--                            :active-value="1"-->
<!--                            :inactive-value="0"-->
<!--                            active-text="是"-->
<!--                            inactive-text="否">-->
<!--                        </el-switch>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item prop="join_end_time" v-if="formData.is_join_end_long === 0">-->
<!--                        <push-time v-model="formData.join_end_time" style="width: 500px;"></push-time>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item prop="end_time" label="投标截止时间" :rules="[{required: formData.is_end_long === 0, message: '投标截止时间必填'}]">-->
<!--                        是否长期有效：-->
<!--                        <el-switch-->
<!--                            v-model="formData.is_end_long"-->
<!--                            active-color="#13ce66"-->
<!--                            :active-value="1"-->
<!--                            :inactive-value="0"-->
<!--                            active-text="是"-->
<!--                            inactive-text="否">-->
<!--                        </el-switch>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item prop="end_time" v-if="formData.is_end_long === 0">-->
<!--                        <push-time v-model="formData.end_time" style="width: 500px;"></push-time>-->
<!--                    </el-form-item>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                    <el-form-item label="报名截止时间" prop="join_end_time" :rules="[{required: true, message: '报名截止时间必填'}]">-->
<!--                        <push-time v-model="formData.join_end_time" style="width: 500px;"></push-time>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="投标截止时间" prop="end_time" :rules="[{required: true, message: '投标截止时间必填'}]">-->
<!--&lt;!&ndash;                        <push-time v-model="formData.end_time" style="width: 500px;"></push-time>&ndash;&gt;-->
<!--	                    <time-picker v-model="formData.end_time" style="width: 500px;"></time-picker>-->
<!--                    </el-form-item>-->
<!--                </template>-->
	            <el-form-item label="标的金额" prop="bids_price" :rules="[{pattern: $regexp.money, message: '请填写正确的金额'},{required: true, message: '标的金额必填'}]">
		            <el-input v-model="formData.bids_price"  maxlength="50" show-word-limit style="width: 500px;">
			            <template slot="append">万元</template>
		            </el-input>
	            </el-form-item>
	            <el-form-item label="货运总量" prop="hyzl" :rules="[{pattern: $regexp.float, message: '请填写正确的货运总量'},{required: true, message: '货运总量必填'}]">
		            <el-input v-model="formData.hyzl"  maxlength="50" show-word-limit style="width: 390px;"></el-input>
		            <el-form-item prop="type_dw_id" class="inline-block">
			            <type-select :can-add="false" v-model="formData.type_dw_id" url="/Type/listAll" :data="{akey:'dw',delete_time:0,state:1,orderBy:'sort',sortBy:'asc'}" class="margin-left" style="width: 100px;"></type-select>
		            </el-form-item>
	            </el-form-item>
<!--                <el-form-item label="项目概况" prop="survey" v-if="formData.user_vip_type !== 'free'" :rules="[{ required: true,message: '项目概况必填'}]">-->
<!--                    <editor v-model="formData.survey" style="width:100%;"/>-->
<!--                </el-form-item>-->
                <el-form-item label="项目概况" prop="survey" class="no-line-height" v-if="formData.user_vip_type !== 'free'" :rules="[{ required: true,message: '项目概况必填'}]">
                    <vue-ueditor-wrap v-model="formData.survey" :config="config" :editor-id="`editor-demo-${Math.round(Math.random() * 99999)}`"></vue-ueditor-wrap>
                </el-form-item>
<!--                <el-form-item label="项目要求" prop="need" v-if="formData.user_vip_type !== 'free'" :rules="[{ required: true,message: '项目要求必填'}]">-->
<!--                    <editor v-model="formData.need" style="width:100%;"/>-->
<!--                </el-form-item>-->
                <el-form-item label="项目要求" prop="need" class="no-line-height" v-if="formData.user_vip_type !== 'free'" :rules="[{ required: true,message: '项目要求必填'}]">
                    <vue-ueditor-wrap v-model="formData.need" :config="config" :editor-id="`editor-demo-${Math.round(Math.random() * 99999)}`"></vue-ueditor-wrap>
                </el-form-item>
                <el-form-item label="详细内容" prop="content" class="no-line-height">
                    <vue-ueditor-wrap v-model="formData.content" :config="config" :editor-id="`editor-demo-${Math.round(Math.random() * 99999)}`"></vue-ueditor-wrap>
                </el-form-item>
<!--                <el-form-item label="详细内容" prop="content">-->
<!--                    <editor v-model="formData.content" style="width:100%;"/>-->
<!--                </el-form-item>-->
                <el-form-item label="附件" prop="files_ids">
                    <file-upload v-model="formData.files_ids" :files="formData['files']"></file-upload>
                </el-form-item>
<!--                <el-form-item label="是否可用" prop="state">-->
<!--                    <el-switch-->
<!--                        v-model="formData.state"-->
<!--                        active-color="#13ce66"-->
<!--                        :active-value="1"-->
<!--                        :inactive-value="0"-->
<!--                        active-text="启用"-->
<!--                        inactive-text="禁用">-->
<!--                    </el-switch>-->
<!--                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import UEditor from "@/components/UEditor";
export default {
    name: "add",
    components: {UEditor},
    data() {
        return {
            params:null,
            inputVisible: false,
            inputValue: '',
            priceType:'1',
            refresh:new Date().getTime(),
            formData: {
                id:'',
                second_type:'coldBid', // 1: 冷链招标 2:冷链需求
                title: '',
                head_img:'',
                title_style: {b:0,i:0,u:0,c:''},
                content: '',
                // state: 1,
                user_vip_type: 'free',
                price: '',
                out_url:'',
                type_industry_id:'',
	            type_fuwu_ids:[],
	            type_dw_id:'',
	            province_codes:[],
                province_code:'',
                province_name:'',
                city_code:'',
                city_name:'',
                tags:[],
                end_time:'',
                join_end_time:'',
                show_zd:1,
                type_zd_id:'',
                type_demand_id:'',
                sort:'',
                is_toutiao:0,
                is_tuijian:0,
                address:'',
                survey:'',
                need:'',
                push_time:'',
                is_join_end_long:0,
                is_end_long:0,
                files_ids:[],
                is_pay:1,
                pay_des:'',
	            bids_price:0.00,
	            hyzl:'',
	            name:'',
	            phone:''
            },
            area:[],
            routerData:null,
            rules: {
                title: [{required: true, message: '标题必填'}],
                content: [{required: true, message: '详细内容必填'}],
                type_industry_id: [{required: true, message: '行业必填'}],
                type_zd_id: [{required: true, message: '标讯类型必填'}],
                type_demand_id: [{required: true, message: '需求类型必填'}],
                // province_code: [{required: true, message: '地区必填'}],
                // end_time: [{required: true, message: '投标截止时间必填'}],
                // join_end_time: [{required: true, message: '报名截止时间必填'}],
                // head_img: [{required: true, message: '标题图片必填'}],
                // address: [{required: true, message: '项目地区必填'}],
                push_time: [{required: true, message: '发布时间必填'}],
                // tags: [{required: true, message: '公司全称必填'}],
	            type_dw_id:[{required:true,message:'货运单位必选'}],
                // survey: [{required: true, message: '项目概要必填'}],
                // need: [{required: true, message: '项目要求必填'}],
            },
            // 行业类别
            industryList:"",
            addIndustryname:"",
            url:'',
            config: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled:false,
                // 初始容器高度
                initialFrameHeight: 240,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: `${this.$config.editUrl}`,
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: '/ueditor/'
            }
        };
    },
    created() {
        this.formData.id  = this.$route.query.id ? this.$route.query.id :'';
        if(!this.formData.id ){
          this.formData.second_type = this.$route.query.secondType ? this.$route.query.secondType :'coldBid';
        }
        let _config = window.config.paths();
        let _path = this.$route.path.replace('/edit','');

        this.params = _config[_path];

        this.routerData = this.params.routerData ? this.params.routerData : {};
    },
    mounted() {
        if(this.formData.id) {
            this.url = this.params.apiUrl+'/edit';
            this.getDetail();

        }else{
            this.url = this.params.apiUrl+'/add';
        }
        // this.getIndustryList()

    },
    methods: {
      // 获取行业类别列表
        getIndustryList(){
            let _this = this;
            // this.$http.httpPost({
            //     url: '/admin/industryCategory/getIndustryCategoryList',
            //     type:"json",
            //     datas:{type:this.$route.query.pageType||this.routerData.type},
            //     success: (res) => {
            //         _this.industryList = res;
            //     }
            // });
	        this.$http.httpPost({
		        url: '/industryCategory/getIndustryCategoryList',
		        datas:{type:this.$route.query.pageType||this.routerData.type},
		        success: (res) => {
			        _this.industryList = res;
		        }
	        });
        },
        submitForm(formName) {
            let _this = this;
            let _endTime = this.formData.end_time;

            // this.formData.end_time = _endTime ? this.$moment(_endTime).format("YYYY-MM-DD") : ''

            this.$refs[formName].validate((valid,obj) => {
                if (valid) {
                    _this.$http.httpPost({
                        url: _this.url,
                        datas: {..._this.formData,..._this.routerData},
                        success: (res) => {
                            _this.$router.back();
                        }
                    });
                } else {
                    let _prop = '';

                    for(let k in obj){
                        _prop = k;
                        break;
                    }

                    if(_prop){
                        _this.$message.error(obj[_prop][0].message)
                    }
                    return false;
                }
            });
        },
        getDetail(){
            let _this = this;
            _this.$http.httpPost({
                url: this.params.apiUrl+'/detail',
                datas: {id:this.formData.id},
                success: (res) => {
                    _this.formData = res;
                     _this.refresh=new Date().getTime();
                    _this.area = [res.province_code,res.city_code];

                    if(res.price === 9.9){
                        _this.priceType = 1;
                    }else if(res.price === 19.9){
                        _this.priceType = 2;
                    }else if(res.price === 3880){
                        _this.priceType = 3;
                    }else{
                        _this.priceType = 4;
                    }
                }
            });
        },

        handleClose(tag) {
            this.formData.tags.splice(this.formData.tags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.formData.tags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },

        changeArea(e){
            console.log(e);
            this.formData.province_name = e === '1' ? '全国' : CodeToText[e];
        },

        changeProvince(e){
            // console.log(e);
            this.formData.province_code = e[0];
            this.formData.province_name = CodeToText[e[0]];
            this.formData.city_code = e[1];
            this.formData.city_name = CodeToText[e[1]];
        },

        change(e){
            // if(e !== 'vip'){
            //     this.formData.price = 0.00;
            // }

            if(e === 'free'){
                this.formData.need = '';
                this.formData.survey = '';

                this.formData.price = 0.00;
            }else if(e === 'user'){
                this.formData.price = 0.00;
            }
        },

        changePriceType(e){
            if(e === 1){
                this.formData.price = '9.9';
            }else if(e === 2){
                this.formData.price = '19.9';
            }else if(e === 3){
                this.formData.price = '3880';
            }else if(e === 4){
                this.formData.price = '';
            }
        }
    }
}
</script>
